export const AI_REPLY_UNIT_PRICE_INR = 0.50
export const GST_PERCENTAGE = 18
export const MAX_TOPUP_UNITS = 30000
